export default __webpack_public_path__ + "static/media/about-picture-4.ee0815b7.jpg";